import type { ModelingFormat } from 'balus-common';
import { ModelingFormatList } from 'balus-common';
import { GROUP_DEFAULT_MODELING_FORMAT_I18N_KEYS } from '@framework/i18n/modelingFormatKeys';
import { useTranslation } from 'react-i18next';

type Props = {
  defaultModelingFormat: ModelingFormat;
  onChange(defaultModelingFormat: ModelingFormat): void;
};

export const DefaultModelingFormatForm: React.FC<Props> = ({ defaultModelingFormat, onChange }: Props) => {
  const { t } = useTranslation();
  const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(event.target.value as ModelingFormat);
  };

  return (
    <div>
      <div>
        <select className="form-select m-1 py-1 text-sm" value={defaultModelingFormat} onChange={handleOnChange}>
          {ModelingFormatList.map((mode) => (
            <option key={mode} value={mode}>
              {t(GROUP_DEFAULT_MODELING_FORMAT_I18N_KEYS[mode])}
            </option>
          ))}
        </select>
      </div>

      <div>{t('group.defaultModelingFormat.note')}</div>
    </div>
  );
};
